<template>

    <TemplateBasic 
      v-bind:breadcrumb="breadcrumb"
      v-bind:permission="permission">

      <div class="row form-group">

        <div class="col">
          <AppAddButton v-bind:permission="permission">
          <a v-bind:href="helper.WEB_URL + '/plApplicationForm'" class="btn btn-rounded btn-primary btn-block-xs-only"> 
            New Parking Application 
          </a>
          </AppAddButton>
        </div>

        <AppSearch 
          ref="pageSearch"
          class="col-md-4"
          v-on:search-data-change="loadData" />
        
      </div>
      
      <AppFilter 
        ref="pageFilter" 
        filterKey="carparkID"
        v-on:filter-data-change="onFilterDataChange" />

      <AppTable 
        ref="pageTable" 
        v-bind:tableParameter="PARAM" 
        v-bind:permission="permission"
        v-on:table-data-click="onTableDataClick" 
        v-on:table-page-change="onTablePageChange" />

      <TemplateFeedback ref="pageFeedback" />

      <AppModalForm 
        ref="pageModal" 
        v-bind:formParameter="PARAM" 
        v-bind:permission="permission"
        v-on:modal-data-add="onModalAddDataClick"
        v-on:modal-data-edit="onModalEditDataClick"
        v-on:modal-data-delete="onModalDeleteDataClick" />

    </TemplateBasic>

</template>

<script>
import TemplateBasic from "@/components/Template/TemplateBasic";
import TemplateButton from "@/components/Template/TemplateButton";
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import AppSearch from "@/components/App/AppSearch";
import AppPaging from "@/components/App/AppPaging";
import AppTable from "@/components/App/AppTable";
import AppAddButton from "@/components/App/AppAddButton";
import AppModalForm from "@/components/App/AppModalForm";
import AppFilter from "@/components/App/AppFilter";
import validation from "@/components/Utility/Validation"
import helper from "@/components/Utility/Helper"

var querystring = require('querystring');

const PARAM = [
  {
    key: '_index',
    index: true,
  },
  {
    key: '_customerType',
    text: 'Type',
  },
  {
    key: '_carparkName',
    text: 'Car Park',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      return `<a target="_blank" href="${helper.WEB_URL}/carparkForm?carparkID=${dataItem.carparkID}">${dataItem['_carparkName']}</a>`;
    },
  },
  {
    key: 'applicationNum',
    text: 'PLA Form No.',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      let pending = '';
      if(dataItem['_pending']) {
        pending = '&pending=1';
      }
      return `<a href="${helper.WEB_URL}/plApplicationForm?carparkID=${dataItem.carparkID}&applicationID=${dataItem.applicationID + pending}">${helper.plFormPLANum(dataItem.applicationID, dataItem.carparkID)}</a>`;
    },
  },
  {
    key: '_licenseNum',
    text: 'Parking License',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      if(!dataItem['licenseID']) {
        return 'N/A';
      }
      if(dataItem['_licenseStatus'] === 'Pending' || dataItem['_licenseStatus'] === 'Pending Initial Payment' || dataItem['_licenseStatus'] === 'Terminated') {
        return helper.plFormPLNum(dataItem._licenseNum, dataItem._carparkNum);
      }
      return `<a target="_blank" href="${helper.WEB_URL}/parkinglicenseView?licenseID=${dataItem.licenseID}">${helper.plFormPLNum(dataItem._licenseNum, dataItem._carparkNum)}</a>`;
    },
  },
  {
    key: '_customerAccount',
    text: 'Account Holder',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex]['_customer'];
      if(!dataItem.id) {
        return '';
      }
      if(dataItem.isCompany) {
        return `<a target="_blank" href="${helper.WEB_URL}/companyForm?customerID=${dataItem.id}">${dataItem.name}</a><br>${dataItem.nationalID}`;
      } else {
        return `<a target="_blank" href="${helper.WEB_URL}/personalForm?customerID=${dataItem.id}">${dataItem.name}</a><br>${dataItem.nationalID}`;
      }
    },
  },
  {
    key: 'commencementDate',
    text: 'Commencement Date',
    table_custom: helper.tableCustomDate,
  },
  {
    key: 'createDate',
    text: 'Date Created',
    table_custom: helper.tableCustomDatetime,
  },
  {
    key: 'status',
    text: 'Status',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      if(dataItem['status2'] === 'Pending') {
        return 'Pending Approval';
      }
      return dataItem['status2'];
    },
  },
];

export default {
  name: "PagePLApplication",
  components: {
    TemplateBasic,
    TemplateButton,
    AppSearch,
    AppPaging,
    AppTable,
    AppAddButton,
    AppModalForm,
    AppFilter,
    TemplateFeedback,
  },
  data () {
    if(helper.checkRoleIsSuperadmin()) {
      PARAM.push({
        key: 'data3',
        text: 'Approved By',
        table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
          let dataItem = dataResult[dataIndex];
          let html = ''
          if(dataItem['data3']) {
            html += dataItem['data3'] || ''
            html += '<br>' + moment.unix(dataItem['date1']).format('YYYY-MM-DD HH:mm')
          }
          return html
        },
      })
      PARAM.push({
        key: 'data4',
        text: 'Rejected By',
        table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
          let dataItem = dataResult[dataIndex];
          let html = ''
          if(dataItem['data4']) {
            html += dataItem['data4'] || ''
            html += '<br>' + moment.unix(dataItem['date2']).format('YYYY-MM-DD HH:mm')

            if(dataItem['status3']) {
              html += '<br>' + dataItem['status3']
            } else if(dataItem['status2'] === 'Rejected') {
              html += '<br>' + dataItem['data2']
            }
          }
          return html
        },
      })
      // PARAM.push({
      //   key: 'status4',
      //   text: 'Void By',
      //   table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      //     let dataItem = dataResult[dataIndex];
      //     let html = ''
      //     if(dataItem['status4']) {
      //       html += dataItem['status4'] || ''
      //       html += '<br>' + moment.unix(dataItem['date3']).format('YYYY-MM-DD HH:mm')

      //       if(dataItem['status5']) {
      //         html += '<br>' + dataItem['status5']
      //       } else if(dataItem['status2'] === 'Void') {
      //         html += '<br>' + dataItem['data2']
      //       }
      //     }
      //     return html
      //   },
      // })
    }
    
    return {
      helper: helper,
      permission : null,
      breadcrumb : [
        { name: 'Home', url: helper.WEB_URL },
        { name: 'Parking License', url: '/parkinglicense' },
        { name: 'Application' },
      ],

      PARAM,

      pageLicense: null,
      pageCustomer: null,
      pageCarpark: null,
    }
  },
  mounted() {
    if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
      return;
    }
    
    this.$refs['pageFilter'].formatFilterOptionText = (dataItem) => dataItem.carparkCode ? `${dataItem.carparkCode} - ${dataItem.name}` : dataItem.name;
    this.loadLicense();
  },
  methods: {
    loadLicense() {
      this.$refs['pageFilter'].setFilterLoading('Loading license data...');

      this.$http
        .get(
          helper.SERVER_URL + '/api2/license/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageLicense = response.data;
          this.loadCustomer();
        })
        .catch(error => {
          this.$refs['pageFilter'].setFilterError(helper.parseAxiosErrorMessage(this, error, 'loading', 'license data'));
        });
    },
    loadCustomer() {
      this.$refs['pageFilter'].setFilterLoading('Loading customer data...');

      this.$http
        .get(
          helper.SERVER_URL + '/api2/customer/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageCustomer = response.data;
          this.loadCarpark();
        })
        .catch(error => {
          this.$refs['pageFilter'].setFilterError(helper.parseAxiosErrorMessage(this, error, 'loading', 'customer data'));
        });
    },
    loadCarpark() {
      this.$refs['pageFilter'].setFilterLoading('Loading customer data...');

      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageCarparkAll = response.data;
          this.pageCarpark = response.data;
          // this.$refs['pageFilter'].setFilterDataWithValueIfFirstLoad([].concat({name: 'All Car Parks'}, response.data), this.$route.query.carparkID);
          this.setCarparInput();
        })
        .catch(error => {
          this.$refs['pageFilter'].setFilterError(helper.parseAxiosErrorMessage(this, error, 'loading', 'car park data'));
        });
    },
    setCarparInput() {
      let feedbackItem = 'car park application data'
      this.$refs['pageFilter'].setFilterLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/request?type1=application',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();

          let allParkingLicense = response.data;
          this.pageCarpark = this.pageCarpark.filter(k => {
            return allParkingLicense.find(j => j.carparkID === k.id)
          });

          let selection = this.pageCarpark;
          if(!helper.checkRoleIsParker()) {
            selection = [].concat({name: 'All Car Parks'}, selection);
          }
          this.$refs['pageFilter'].setFilterDataWithValueIfFirstLoad(selection, this.$route.query.carparkID);
          this.loadData();
        })
        .catch(error => {
          this.$refs['pageFilter'].setFilterError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadData() {
      let feedbackItem = 'application data';
      this.$refs['pageTable'].setTableLoading('Loading ' + feedbackItem);

      let url = this.getUrl(this.$refs['pageFilter'].filterValue);
      url = helper.appendSearchQuery(url, this.$refs['pageSearch'].searchValue);

      if(JSON.parse(localStorage.getItem('user')).username !== 'ybjason+11011@gmail.com') {
        url = helper.appendPagingQuery(url, this.$refs['pageTable'].getCurrentPage());
      }

      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response, true);
          if(this.$refs['pageFilter'].filterValue) {
            response.data = response.data.filter(k => helper.compareID(k.carparkID, this.$refs['pageFilter'].filterValue))
          }
          response.data = Object.values(response.data.reduce(function(result, data) {
            if(!result[data['applicationID']]) {
              result[data['applicationID']] = data;
            }
            return result;
          }, {}));

          if(JSON.parse(localStorage.getItem('user')).username === 'kahwei.chuah@july.technology') {
            response.data.sort((a, b) => b.createDate - a.createDate);
          }
          
          response.data.forEach(k => {
            k['_license'] = this.pageLicense.find(j => j.id === k['licenseID']) || {};
            k['_licenseStatus'] = k['_license']['status'];
            k['_licenseNum'] = k['_license']['licenseOperatorNum'];
            k['_carparkNum'] = k['_license']['carparkID'];
            k['_carpark'] = this.pageCarparkAll.find(j => j.id === k['carparkID']) || {};
            k['_carparkName'] = (k['_carpark'] || {}).name;
            k['_customer'] = this.pageCustomer.find(j => j.id === k['customerID']) || {};
            k['_customerType'] = (k['_customer'] || {}).isCompany ? 'Company' : 'Personal';
          });
          if(this.$route.path.includes('Pending')) {
            response.data = response.data.filter(k => {
              k['_pending'] = true;
              return k['status1'] === 'Pending' || k['status1'] === 'Pending Approval'
            });
          }

          this.$refs['pageTable'].setTableData(response.data, this.$refs['pageTable'].getCurrentPage());
        })
        .catch(error => {
          this.$refs['pageTable'].setTableError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },

    getUrl(carparkID) {
      let url = helper.SERVER_URL + '/api2';
      url += '/requestgroup?type1=application&sort=createDate';
      if(carparkID) {
        url += '&carparkID=' + carparkID;
      }
      if(this.$route.path.includes('Pending')) {
        url += '&status1=Pending Approval';
      }
      return url;
    },

    onAddButtonClick() {
      this.$refs['pageFeedback'].setFeedbackMessage();
      this.$refs['pageModal'].setModalOpen(true, 'Add New City');
    },
    onTableDataClick(tableData, tableDataIndex) {
      this.$refs['pageFeedback'].setFeedbackMessage();
      this.$refs['pageModal'].setModalOpen(false, 'Edit ' + tableData[tableDataIndex]['name'], tableData[tableDataIndex]);
    },

    onTablePageChange() {
      this.loadData();
    },
    onSearchChange(dataIndex) {
      this.$refs['pageTable'].setCurrentPage(1);
      this.loadData();
    },
    onFilterDataChange(dataIndex) {
      this.$refs['pageTable'].setCurrentPage(1);
      this.loadData();
    },

    onModalAddDataClick(selectedData) {
      this.$refs['pageModal'].setModalLoading('Adding ' + selectedData.name);

      this.$http
        .post(
          this.getUrl(),
          querystring.stringify(selectedData),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.upsertDataComplete('Successfully added ' + selectedData.name);
        })
        .catch(error => {
          this.$refs['pageModal'].setModalError(helper.parseAxiosErrorMessage(this, error, 'adding', selectedData.name));
        })
    },
    onModalEditDataClick(selectedData) {
      this.$refs['pageModal'].setModalLoading('Updating ' + selectedData.name);

      this.$http
        .put(
          this.getUrl(),
          querystring.stringify(selectedData),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.upsertDataComplete('Successfully update ' + selectedData.name);
        })
        .catch(error => {
          this.$refs['pageModal'].setModalError(helper.parseAxiosErrorMessage(this, error, 'updating', selectedData.name));
        })
    },
    onModalDeleteDataClick(selectedData) {
    },
    upsertDataComplete(message) {
      this.$refs['pageModal'].setModalClose();
      this.$refs['pageFeedback'].setFeedbackMessage(message);
      this.loadData();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/ParkingLicense/PagePLApplication.vue